import React from 'react'
import {observer} from 'mobx-react-lite'
import {DateTimezoneState} from './datetimeTimezoneState'
import {definedContextValueHookFactory} from '@oc/hooks'

const DateTimezoneStateContext = React.createContext<DateTimezoneState | null>(null)

export const useDateTimezoneState = definedContextValueHookFactory(DateTimezoneStateContext, 'DateTimezoneStateContext')

export function DateTimezoneStateContextProvider({children}: React.PropsWithChildren) {
    const [state] = React.useState(() => new DateTimezoneState())
    return <DateTimezoneStateContext.Provider value={state}>{children}</DateTimezoneStateContext.Provider>
}

export default observer(DateTimezoneStateContextProvider)
